<template>
  <div class="tabs columns--5 active--bar">
    <ul class="clearfix OPTION w--1200px m--auto">
      <li
        class="tab__title"
        v-for="(image, index) in tabs"
        :key="index"
        :class="index === currentIndex ? 'is-selected' : ''"
      >
        <!-- <a > -->
        <button
          type="button"
          @click="select(index)"
        >
          <img
            @click="select(index)"
            :src="`/api/resources/files/${tabs[index]}`"
            class="w--100%"
          >
        </button>
        <!-- </a> -->
      </li>
    </ul>

    <div class="tab__content is-selected">
      <img
        :src="`/api/resources/files/${images[currentIndex]}`"
        class="img--center w--1920px"
      >
    </div>
  </div>

</template>

<script>
export default {
  props: {
    images: { type: Array },
    tabs: { type: Array }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    select (index) {
      this.currentIndex = index
    }
  },
  components: {
  }
}
</script>
